import { lazy, Suspense, useEffect, useMemo, useState } from 'react'
import { usePage } from '@inertiajs/react'
import {
  subscribeAssistantChatCornerRequests,
  subscribeEmbeddedAssistantChatVisibility,
} from '@/frontend/features/AgentChats/assistant-ui/assistantChatSurfaceBus'
import { persistWidgetState } from '@/frontend/features/AgentChats/assistant-ui/widgetStateStorage'
import type { SharedProps } from '@/frontend/types/inertia'

const AssistantFloatingWidget = lazy(() =>
  import('@/frontend/features/AgentChats/assistant-ui/components/AssistantFloatingWidget')
    .then((module) => ({ default: module.AssistantFloatingWidget })),
)

export default function AssistantFloatingWidgetHost({ hidden = false }: { hidden?: boolean }) {
  const page = usePage<SharedProps>()
  const [embeddedChatVisible, setEmbeddedChatVisible] = useState(false)
  const [widgetMountKey, setWidgetMountKey] = useState(0)
  const storageContext = useMemo(() => ({
    userId: page.props.auth.user?.id,
    organizationId: page.props.auth.user?.active_organization?.id,
  }), [page.props.auth.user?.id, page.props.auth.user?.active_organization?.id])

  useEffect(() => subscribeEmbeddedAssistantChatVisibility(setEmbeddedChatVisible), [])
  useEffect(() => subscribeAssistantChatCornerRequests(({ workerId, sessionId }) => {
    persistWidgetState({ open: true, workerId, sessionId, editProcessId: null }, storageContext)
    setWidgetMountKey((current) => current + 1)
  }), [storageContext])

  return (
    <Suspense fallback={null}>
      <AssistantFloatingWidget key={`${storageContext.userId}:${storageContext.organizationId}:${widgetMountKey}`} hidden={hidden || embeddedChatVisible} />
    </Suspense>
  )
}
